import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const systemOwnerDetailsCardPlugin = createPlugin({
  id: 'system-owner-details-card',
  routes: {
    root: rootRouteRef,
  },
});

export const SystemOwnerDetailsCard = systemOwnerDetailsCardPlugin.provide(
  createRoutableExtension({
    name: 'SystemOwnerDetailsCard',
    component: () => import('./components/SystemOwnerDetailsCard').then((m) => m.SystemOwnerDetailsCard),
    mountPoint: rootRouteRef,
  }),
);
